import React from 'react';
import { Table, Loader } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';

import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grades: {},
            gradesArray: [],

            loading: true,
            showGrades: false
        };
    }

    componentDidMount() {
        axios.get(`/student-exams/grades/${this.props.studentId}`)
            .then(res => {
                const grades = res.data;
                const gradesArray = res.data.grades;

                this.setState({
                    grades, gradesArray, loading: false, average: grades.gradeAverage
                });
            })
            .catch(err => {
                console.log('Failed to fetch student grades');
            });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        const { gradesArray, average, grades } = this.state;
        return (
            <div>
                {gradesArray.length ? <Table structured celled selectable compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2}>
                                <FormattedMessage id="common.course" />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <FormattedMessage id="common.teacher" />
                            </Table.HeaderCell>
                            <Table.HeaderCell width={1}>
                                ECTS
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <FormattedMessage id="professorInputGrades.examOnlyDate" />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <FormattedMessage id="professorInputGrades.inputGradeDate" />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <FormattedMessage id="common.grade" />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body> {gradesArray.map((el, index) =>
                        (<Table.Row key={el.id}>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                {el.courseName}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {el.teacher}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" width={1}>
                                {el.ects}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {moment(el.examDate).format('D. M. YYYY.')}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : ''}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {el.mark}
                            </Table.Cell>
                        </Table.Row>))}
                    </Table.Body>

                    <Table.Footer>
                        <Table.Row >
                            <Table.HeaderCell colSpan="5" rowSpan="3" />
                            <Table.HeaderCell colSpan="2">
                                <h4>  {<FormattedMessage id="common.gradeAverage" />}{average}</h4>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                            <Table.HeaderCell colSpan="2">
                                <h4>  {<FormattedMessage id="common.totalEcts" />} {grades.ectsTotal}</h4>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                            <Table.HeaderCell colSpan="2">
                                <h4>  <FormattedMessage id="student.passedExamsNumber" />: {gradesArray.length}</h4>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                        </Table.Row>
                    </Table.Footer>
                </Table>
                    : 'Student nema ocjena.'}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/StudentGrades.js